import {
  SET_LANGUAGE,
  SET_LANGUAGE_SUCCESS,
  SET_LANGUAGE_FAILURE,
} from "./types";

// Initial state type definition
interface LanguageState {
  language: "de" | "en";
  loading: boolean;
  error: string | null;
}

// Initial state
const initialState: LanguageState = {
  language: "de", // Default language
  loading: false,
  error: null,
};

// Reducer to handle language-related actions
const languageReducer = (state = initialState, action: any): LanguageState => {
  switch (action.type) {
    case SET_LANGUAGE:
      return {
        ...state,
        loading: true, // Start loading when language is being set
      };
    case SET_LANGUAGE_SUCCESS:
      return {
        ...state,
        language: action.payload,
        loading: false,
      };
    case SET_LANGUAGE_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};

export default languageReducer;
